import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useEffect} from "react";
import useAuth from "../../hooks/useAuth";
import { ROLES } from "../../constant/roles";
import { toast } from "react-toastify";

const RequireAuth = ({ allowedRoles }) => {
  const auth = useAuth();
  const location = useLocation();

  const navigateRoutes = () => {
    if (auth?.roleId === ROLES.systemAdmin)
      return "/system-admin/license-master";
    else if (auth?.roleId === ROLES.allianceManager)
      return "/alliance-manager/dashboard";
    else if (auth?.roleId === ROLES.vendor) return "/vendor/dashboard";
    else if (auth?.roleId === ROLES.executive) return "/executive/dashboard";
    else if (auth?.roleId === ROLES.fieldExecutive)
      return "/field-executive/dashboard";
    else if (auth?.roleId === ROLES.customerSupport)
      return "/customer-support/dashboard";
  };

  useEffect(() => {
    if (auth?.isAuthenticated && !allowedRoles?.includes(auth?.roleId)) {
      toast.error("You do not have access to this page!");
    }
  }, [auth, allowedRoles]);

  return auth?.isAuthenticated && auth?.mustChangePassword ? (
    <Navigate to="/force-change-password" state={{ from: location }} replace />
  ) : allowedRoles?.includes(auth?.roleId) ? (
    <Outlet />
  ) : auth?.isAuthenticated ? (
    <Navigate to={navigateRoutes()} state={{ from: location }} replace /> //redirect to login because we do not handle 404 page or unauthenticate page.
  ) : (
    <Navigate to="/admin/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
